import { useContext, useEffect, useReducer, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { v4 as uuidv4 } from "uuid";
import { Store } from "../Store";
import { getError } from "../utils";
import useAxios from "./useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useLiveOrders() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { carts, userInfo } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadOrders, setLoadOrders] = useState(false);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const fetchOrders = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });

      const { data } = await axios.get(
        `/api/customer/orders?${isTabletOrMobile ? "" : "homeOrder=true"}`
      );

      const orders = data.orders.map((tableOrder) => {
        const items = tableOrder.orderItems.map((item) => ({
          ...item.product,
          menuName: item.name,
          price: item.price || item.product.price,
          quantity: item.quantity,
          tableNum: tableOrder.tableNum,
          createdAt: item.createdAt,
          itemCode: item.itemCode,
          relativeItem: item.relativeItem,
          mainPrice: item.mainPrice,
          tableCode: tableOrder.tableCode,
          feature: item.feature,
          clientCode: item.clientCode || tableOrder.clientCode,
          customerName: item.customerName || tableOrder.description,
          address: item.address,
          answers: item.answers,
          alert: item.alert,
          isPartialPaid: item.isPartialPaid,
        }));
        return {
          description: {
            tableNum: tableOrder.tableNum,
            clientCode: tableOrder.clientCode,
            user: tableOrder.user,
            tableCode: tableOrder.tableCode,
            customerName: tableOrder.description,
            alert: tableOrder.alert,
            orderCode: tableOrder.orderCode || uuidv4(),
            alertTimePeriod: tableOrder.alertTimePeriod,
            onBusinessUser: tableOrder.onBusinessUser,
            tableType: tableOrder.tableType,
            alertOn: tableOrder.alertOn ?? true,
            partialCache: tableOrder.partialCache,
            partialPOS: tableOrder.partialPOS,
          },
          items,
        };
      });

      ctxDispatch({
        type: "CUSTOMER_SET_ORDERS",
        payload: { orders },
      });

      dispatch({ type: "FETCH_SUCCESS", payload: data });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (loadOrders) {
      fetchOrders();
      setLoadOrders(false);
    }
  }, [loadOrders]);

  return [loading, error, setLoadOrders];
}
